import { ResponsiveTableColumn } from 'modules/shared-components/data-display/table/types';
import { WalletRowInfoV2 } from 'api/types/httpsTypes/contracts';
import { FC } from 'react';
import classNames from 'classnames';
import ErrorBoundary from 'components/error-boundaries';
import Table from 'modules/shared-components/data-display/table';
import { useHistory, Link } from 'react-router-dom';
import { screenGte, useMediaQuery } from 'modules/media/use-media-query';
import { Tabs } from '../../../components/layout/SIDEBAR_CONST';

interface Props {
  columnsDef: ResponsiveTableColumn<WalletRowInfoV2>[];
  data: WalletRowInfoV2;
}

export const TableRow: FC<Props> = ({ data, columnsDef }) => {
  const history = useHistory();

  const isDesktop = useMediaQuery(screenGte.large);

  const classes = classNames(
    'border-tailwind xxs:border-solid xxs:border-x-0 xxs:border-b-0 border-dex-black-700 lg:dark:bg-dex-black-900 cursor-pointer items-center hover:dark:lg:bg-dex-black-800 lg:grid lg:grid-cols-11'
  );

  const MainBody = () => {
    return (
      <ErrorBoundary>
        {columnsDef.map((column) => {
          const Column = column.component;
          if (!Column) return;
          return (
            <Table.Td
              className={
                column.key === 'UNIQUE_TOKENS' || column.key === 'ADDRESS'
                  ? 'lg:col-span-2'
                  : ''
              }
              key={column.key}
            >
              <Column data={data} />
            </Table.Td>
          );
        })}
      </ErrorBoundary>
    );
  };
  return isDesktop ? (
    <Link
      to={{
        pathname: `/dex/research/${Tabs.Wallets}/${data.chain}/${data.address}/analytics`,
        state: {
          from: `${history.location.pathname}${history.location.search}`,
        },
      }}
      className={classes}
    >
      <MainBody />
    </Link>
  ) : (
    <tr
      onClick={() =>
        history.push({
          pathname: `/dex/research/${Tabs.Wallets}/${data.chain}/${data.address}/analytics/${Tabs.Performance}`,
          state: {
            from: `${history.location.pathname}${history.location.search}`,
          },
        })
      }
      className={classes}
    >
      <MainBody />
    </tr>
  );
};
